global.initIcons = function(target) {
    var iconsPlugins = (target)?$(target).find('.iconGrid').not('.iconGridGen'):$('.iconGrid').not('.iconGridGen');
    var iconsPlugins = iconsPlugins.iconsView(global.iconViewDefaultSettings);

    target.find('.ico:not([data-ico=""])').each(function() {
        if ($(this).data('ico') && !$(this).html()) {
            $(this).html(iconImg($(this).data('ico'), '', null, $(this).data('fill'), $(this).data('size')));
            if (isNumeric($(this).data('size'))) {
                $(this).width($(this).data('size'));
                $(this).height($(this).data('size'));
            }
        }
    })
}

global.icon = function($icon, $size = 24, $class = "", $title = null) {
    if (typeof $icon !== "string") return '';

    let $span = $("<span>")
        .addClass($.trim($class + " ico"))
        .attr("data-size", $size)
        .attr("data-ico", $icon);

    if ($title) {
        $span.attr("title", $title);
    }

    return $span.prop("outerHTML");
}


global.initSvg = function(target) {
    target.find('svg').each(function() {
        var outer = this.outerHTML;

        // Replace opening tag
        var regex = new RegExp('<' + this.tagName, 'i');
        var newTag = outer.replace(regex, '<' + 'span');

        // Replace closing tag
        regex = new RegExp('</' + this.tagName, 'i');
        newTag = newTag.replace(regex, '</' + 'span');
        newTag = $(newTag);

        $(this).replaceWith(newTag);
        $(newTag).replaceWith(outer);
    });
}

global.initMediabox = function(target) {
    var cursorTest = {};
    target.find('.imgbox, .page--hidden .page__content').mousedown(function(e) {
        cursorTest = {"x": e.clientX, "y": e.clientY}
    })

    target.find('.imgbox, .page--hidden .page__content').click(function(e) {
        if (e.clientX < cursorTest.x - 6 || e.clientX > cursorTest.x + 6 ||
            e.clientY < cursorTest.y - 6 || e.clientY > cursorTest.y + 6) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
}

global.iconImg = function(src, classe, extra, fill, size) {
    if (!fill) fill = 'contain';
    if (!size) size = 'auto';
    let iconDom = $('<div draggable="false" '+extra+'></div>');
    if (typeof src == 'string') {
        src = src.split('|');
        var data = {
            'size': size,
            'data': [{
                'src': src[0]
            }],
            'fill': fill,
        };
        if (src[1]) {
            data.data.push({
                'src': src[1],
                'size' : 50
            });
        }
    }
    else {
        data = {
            'size': size,
            'data': src,
            'fill': fill
        };
    }
    //console.log(data);
    iconDom.icons(data);
    iconDom.children().addClass(classe);
    return iconDom.html();
}

global.getImageLightness = function(imageSrc,callback) {
    var img = document.createElement("img");
    img.src = imageSrc;
    img.style.display = "none";
    document.body.appendChild(img);

    var colorSum = 0;

    img.onload = function() {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(this,0,0);

        var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
        var data = imageData.data;
        var r,g,b,a,avg;
        var total = 0;
        var hasAlphaPixels = false;

        for(var x = 0, len = data.length; x < len; x+=4) {
            r = data[x];
            g = data[x+1];
            b = data[x+2];
            a = data[x+3];

            if (a > 250) {
                avg = Math.floor((r + g + b) / 3);
                colorSum += avg;
                total++;
            }

            if (a < 255) {
                hasAlphaPixels = true;
            }
        }

        var brightness = Math.floor(colorSum / total);
        callback(brightness, hasAlphaPixels, canvas.width, canvas.height);
    }
}
